import $ from 'jquery';

export const formValidator = new function () {

    'use strict';

    this.isEmpty = function (text) {

        return !/[^\s]/.test(text);
    };

    this.validateEmailSyntax = function (email) {

        var expr = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return expr.test(email);
    };

    this.validateConatctNo = function (contactNo) {
        var expr = /^[0-9\s\+\-]+$/;
        return expr.test(contactNo);
    };

    this.validateStringField = function (stringField) {
        var expr = /^[a-z|A-Z\u0600-\u06FF\s\.\'\-\,]+$/;
        //var expr = /^[a-z|A-Z\u0621-\u064A\u0660-\u0669\s\.\'\-\,]+$/;
        return expr.test(stringField);
    };

    this.validateDropDownRequired = function (value) {

        return value > 0;
    };

    this.getLanguage = function () {

        var language = document.documentElement.lang;

        language = language === "" || language === undefined ? "ar" : language;

        return language;
    };

    this.ValidTextArea = function(inputText) {
        var regex = /^[ A-Za-z0-9\u0600-\u06FF;,://\\%#.?()$_@@"'”’-\s]*$/;
        return regex.test(inputText);
    }

    this.clearOneErrorMessage = function (id) {
        $('#' + id).remove();
    }

    this.setErrorMessage = function (element, message, id) {
        if (!$('#' + id).html()) {
          element.parent().append('<div id="' + id + '" class="form__input-error"><span class="help-block"><span class="field-validation-error">' + message + '</span></span></div>');
        }
    }

    this.setErrorMessageForCategory = function (element, message, id) {
      if (!$('#' + id).html()) {
          element.closest('.form__group').append('<div id="' + id + '" class="form__input-error"><span class="help-block"><span class="field-validation-error">' + message + '</span></span></div>');
        }
    }

    this.validPassword = function (value) {

        // var regex = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{7,}$/;
        var regex = /^(?=.*[A-Z])(?=.*[" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"])(?=.*[0-9])(?=.*[a-z]).{7,}$/;
        return regex.test(value);
    }

}
